/**
 * Sitzungsmarke "Kauf wartet auf Bestaetigung" (UX-Audit G4-03, Ruling N2):
 * Zeitstempel der ersten Rueckkehr aus dem Stripe-Checkout, solange der
 * Webhook das Abo noch nicht aktiviert hat. Leser und Schreiber ist
 * `useCheckoutSuccess`; `AuthContext` raeumt sie beim Abmelden und beim
 * Nutzerwechsel (Ruling N4), wie den Plan-Cache.
 *
 * Ohne Importe, damit `AuthContext` sie nutzen kann, ohne den Hook (und damit
 * `useSubscription`) in seinen Importgraphen zu ziehen. Jeder Zugriff ist in
 * try/catch: ein gesperrter Speicher (privates Fenster) darf nie werfen.
 */
export const CHECKOUT_AWAITING_KEY = 'checkout_awaiting';
/**
 * So lange gilt die Marke. Lang genug fuer einen verspaeteten Webhook, kurz
 * genug, dass ein vergessener Tab nicht tagelang "Zahlung wird bestaetigt" meldet.
 */
export const CHECKOUT_AWAITING_TTL_MS = 6 * 60 * 60 * 1000;
/**
 * So weit darf eine Marke in der Zukunft liegen und trotzdem gelten. Springt
 * die Uhr kurz nach dem Setzen zurueck (NTP-Korrektur) und folgt ein Reload,
 * liegt die frische Marke knapp vor "jetzt". Ohne Toleranz verfiele sie, und
 * ein spaeter Webhook meldete den Kauf nicht mehr.
 */
const CLOCK_SKEW_TOLERANCE_MS = 5 * 60 * 1000;

export function isCheckoutAwaiting(): boolean {
  try {
    const at = Number(sessionStorage.getItem(CHECKOUT_AWAITING_KEY));
    if (!Number.isFinite(at) || at <= 0) return false;
    const age = Date.now() - at;
    // Eine Marke, die mehr als fuenf Minuten in der Zukunft liegt (Uhr
    // verstellt, Hand-Eingriff), galt sonst um ihren Vorlauf laenger als die
    // 6 h. Sie gilt gar nicht; das naechste markCheckoutAwaiting() ersetzt sie
    // durch den aktuellen Zeitstempel. Kleine Rueckspruenge der Uhr duerfen eine
    // frische Marke dagegen nicht entwerten, daher die Toleranz.
    return age > -CLOCK_SKEW_TOLERANCE_MS && age < CHECKOUT_AWAITING_TTL_MS;
  } catch {
    return false;
  }
}

/**
 * Setzt die Marke nur, wenn keine gueltige steht: die Frist laeuft ab der
 * ERSTEN Rueckkehr, ein Reload verlaengert sie nicht.
 */
export function markCheckoutAwaiting(): void {
  try {
    if (!isCheckoutAwaiting()) sessionStorage.setItem(CHECKOUT_AWAITING_KEY, String(Date.now()));
  } catch {
    // Speicher gesperrt: der Ref im Hook traegt den Zustand, bis die Seite verlassen wird.
  }
}

export function clearCheckoutAwaiting(): void {
  try {
    sessionStorage.removeItem(CHECKOUT_AWAITING_KEY);
  } catch {
    // siehe markCheckoutAwaiting
  }
}
